import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum, StatementEntity, StatementsApi, StatementSearchParams } from '@shared/api';

interface IStatementsStore {
  loading: boolean;
  error: string | null;
  statements: StatementEntity[];
  getStatements: (searchParams: StatementSearchParams, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useStatementsStore = create<IStatementsStore>((set) => ({
  loading: false,
  error: null,
  statements: [],

  getStatements: ApiUtils.wrapperApi(async (searchParams: StatementSearchParams, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await StatementsApi.getStatements(searchParams, signal);
      set({ statements: result ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ statements: [], loading: false, error: null }),
}));
